import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect';
import SideNavClass from './SideNavClass';
import { MDBAlert, MDBBadge, MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBCheckbox, MDBChip, MDBCol, MDBDatepicker, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow, MDBSelect, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane, MDBTextArea, MDBTimepicker } from 'mdb-react-ui-kit';
// import ClassesBooking from './ClassesBooking';
import ClassesBooking from './newClassesBooking';
import CreateEvent from '../../components/class/createEvent';
import { deleteSchedule, getCancellationPolicy, getClass, getSchedule, getTrainer, getGymPlansList, getStaffProfile, getStaffInfo } from '../../services/classApiServices.js';
import moment from 'moment';
import { formatDate, formatDateTimeWithTZ } from '../../utils/DateFormat';
import { browserName, browserVersion } from "react-device-detect";
import { logEvent } from '../../services/apiServices';
import NewClassesView from '../newClassesPage';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useAccess } from '../../context/AccessContext';



const dayMap = {
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
    0: 'Sun'
};


const getWeekOrdinal = (weekNumber) => {
    if (weekNumber === 1) return "1st week";
    if (weekNumber === 2) return "2nd week";
    if (weekNumber === 3) return "3rd week";
    return `${weekNumber}th week`;
};


const monthMap = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
};

const ClassSchedules = () => {
    const { trackButtonClick } = useAnalytics();
    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
    const isAdmin = loggedUserInfo?.role !== "staff";
    const [modeOpen, setModeOpen] = useState(true);
    const [mode, setMode] = useState('side');
    const [centredModal, setCentredModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const toggleDeleteModal = () => setDeleteModal(!deleteModal);

    const [basicActive, setBasicActive] = useState('tab2');
    const [refresh, setRefresh] = useState(false)
    const [eventid, setEventid] = useState(-1)
    const [scheduleData, setScheduleData] = useState(null)
    const [scheduleInfo, setScheduleInfo] = useState([])
    const [classes, setClasses] = useState([])
    const [policyData, setPolicyData] = useState([])
    const [trainerData, setTrainerData] = useState([])
    const [plans, setPlans] = useState([])
    const [schedulesArray, setSchedulesArray] = useState([])
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("all");
    const [filteredSchedules, setFilteredSchedules] = useState([]);
    const [Error2, setError2] = useState("")


    const [selectedDate, setSelectDate] = useState(null)

    const { loading, handlePageAccess, handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("schedules")
    useEffect(() => {
        if (isMobile) {
            setModeOpen(false)
            setMode("over")
        }
    }, [])


    useEffect(() => {

        const fetchData = async () => {
            const response = await getSchedule(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response === "false") {
                return;
            }
            const scheduleinfo = await response.json();

            console.log(scheduleinfo, 'sssssssssss');
            setScheduleInfo(scheduleinfo)
            setRefresh(false)
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
        }


    }, [refresh])

    useEffect(() => {

        async function fetchPlans() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getGymPlansList(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, "class"
                );
                if (!response) {
                    return;
                }
                if (response === "false") {
                    // setApiError(true)
                } else {
                    const tempData = await response.json();


                    setPlans(tempData);

                }

            }
        }

        fetchPlans();

    }, []);


    useEffect(() => {

        const fetchData = async () => {
            const response = await getClass(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response === "false") {
                return;
            }
            const classinfo = await response.json();

            console.log(classinfo, 'classsssssssss');
            setClasses(classinfo)


            // setRefresh(false)
        }
        const fetchStaffData = async () => {
            const trainerres = await getStaffInfo(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!trainerres || trainerres === "false") {
                return;
            }
            const trainerinfo = await trainerres.json();

            console.log(trainerinfo, 'trainerinfo');
            setTrainerData(trainerinfo)

        }
        const fetchPolicyData = async () => {
            const res = await getCancellationPolicy(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            console.log(res);

            if (!res || res === "false") {
                return;
            }
            const policyinfo = await res.json();

            console.log(policyinfo, 'Policyinfo');
            setPolicyData(policyinfo)
        }

        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
            fetchPolicyData()
            fetchStaffData()
        }


    }, [])

    useEffect(() => {
        const schedulesArray = generateSchedules(scheduleInfo, classes, trainerData, policyData);
        setSchedulesArray(schedulesArray)
        setFilteredSchedules(schedulesArray)
    }, [scheduleInfo, classes, trainerData, policyData])

    const generateSchedules = (scheduleInfo, classes, trainerData, policyData) => {

        return scheduleInfo.length > 0 ? scheduleInfo.map(schedule => {
            const classInfo = classes.length > 0 ? classes.find(cls => cls._id === schedule.classid) : {};
            const trainerInfo = trainerData && trainerData.length > 0 ? trainerData.find(trainer => trainer._id === schedule.trainerid) : {};
            const policyInfo = policyData && policyData.length > 0 ? policyData.find(policy => policy._id === schedule.cancellationpolicyid) : {};
            const formatDate = (dateString) => {
                console.log(dateString);

                return moment(dateString, 'YYYY-MM-DD').isValid()
                    ? moment(dateString).format('YYYY-MM-DD')
                    : "";
            };
            const currentDate = new Date();

            const status =
                schedule?.totalslots > schedule?.bookedslots && new Date(schedule.enddate) > currentDate
                    ? "active"
                    : schedule?.totalslots === schedule?.bookedslots
                        ? "full"
                        : new Date(schedule?.enddate) < currentDate
                            ? "inactive"
                            : "active";
            return {
                id: schedule._id,
                className: classInfo && classInfo?.name ? classInfo.name : "Unknown Class",
                weekdays: schedule?.recurrence?.value || [],
                recurrencetype: schedule?.recurrence?.recurrencetype || "daily",
                timeSlot: schedule?.timeslot,
                instructor: trainerInfo?.firstname ? (trainerInfo.firstname + " " + trainerInfo.lastname) : "Unknown Trainer",
                capacity: schedule?.totalslots ? parseInt(schedule.totalslots, 10) : 0,
                enrolledCount: schedule?.bookedslots ? parseInt(schedule.bookedslots, 10) : 0,
                location: schedule?.location || "N/A",
                startDate: (schedule?.startdate),
                endDate: (schedule?.enddate),
                status: status,
                policy: policyInfo?.name ? policyInfo?.name : "No Policy",
                scheduleinfo: schedule

            };
        }) : []
    };

    // const schedulesArray = generateSchedules(scheduleInfo, classes, trainerData, policyData);
    // console.log(schedulesArray);
    // let filteredSchedules = schedulesArray


    const handleApplyFilter = () => {
        console.log('active', selectedStatus, searchTerm, '999999999999999999999');

        let filtered = schedulesArray.filter(schedule =>
            (schedule.className.toLowerCase().includes(searchTerm.toLowerCase()) ||
            schedule.instructor.toLowerCase().includes(searchTerm.toLowerCase())) &&
            (selectedStatus === "all" || schedule.status === selectedStatus)
        );
        console.log(filtered);

        setFilteredSchedules(filtered);
        // filteredSchedules = filtered
    };

    const handleCancelFilter = () => {
        setSearchTerm("");
        setSelectedStatus("all");
        setFilteredSchedules(schedulesArray);
        // filteredSchedules = schedulesArray

    };

    console.log(filteredSchedules);
    console.log(schedulesArray, "schedulesArray");


    const sideNav = () => {
        setModeOpen(!modeOpen);
        if (isMobile) {
            setMode("over")
        } else {
            setMode("side")
        }
    }

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };


    const handleSave = async () => {
        const user = JSON.parse(localStorage.getItem("loggedUserInfo"));
        const fullName = user?.name || `${user?.fname || ""} ${user?.lname || ""}`.trim() || "User";
        const username1 = user?.email || "Guest";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;
        const gymid = user.gymid;

        const Eventtype = scheduleData?._id ? "Class Schedule Updated" : "Class Schedule Created";
        const flag = scheduleData?._id
            ? `Schedule Updated Successfully (${fullName})`
            : `Schedule Created Successfully (${fullName})`;
        setError2(flag);

        try {
            await logEvent({
                Eventtype,
                username1,
                fullName,
                ip,
                flag,
                browserinfo,
                gymid,
                isclass: true
            }, gymid);
            await trackButtonClick("ClassSchedule", scheduleData?._id ? "Update_Schedule" : "Create_Schedule", "staff", {});
        } catch (err) {
            console.error("Failed to log event:", err);
        }

        setScheduleData(null);
        setRefresh(true);
        setCentredModal(false);
    };

    const handleClose = () => {
        setScheduleData(null);
        toggleOpen()
    }

    const [eventdata, setEventdata] = useState(null)
    const handelEditCallback = (event, date) => {
        setSelectDate(date)
        setScheduleData(event)
        setRefresh(true)
        setCentredModal(true);
    }

    const handlealertDelete = (id) => {
        setEventid(id)
        setDeleteModal(true)

    }

    const handelDeleteCallback = async (id, isapplied) => {

        const user = JSON.parse(localStorage.getItem("loggedUserInfo"));
        const fullName = user?.name || `${user?.fname || ""} ${user?.lname || ""}`.trim() || "User";
        const username1 = user.email || "user";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;
        const gymid = user.gymid;

        try {
            const res = await deleteSchedule(gymid, id, isapplied);
            const flag = `Schedule deleted successfully (${fullName})`;
            setError2(flag);

            await logEvent({

                Eventtype: username1,
                username1,
                fullName,
                ip,
                flag,
                browserinfo,
                gymid,
                isclass: true,
            }, gymid);
            await trackButtonClick("ClassSchedule", "Delete_Schedule", "staff", {});
            setRefresh(true)
        } catch (err) {
            console.error("Failed to delete schedule or log event:", err);
        }
    };
    const handleDeleteConform = (e, isapply) => {
        handelDeleteCallback(eventid, isapply)
        setDeleteModal(false)
    }
    return (
        <>
            <SideNavClass activeTab={"classschedules"} modeOpen={modeOpen} setModeOpen={setModeOpen} mode={mode} setMode={setMode} >
                {isMobile && <>
                    <header class="gym-container gym-hide-large gym-red  gym-padding d-flex align-items-center p-3">
                        <div onClick={() => sideNav()} className='cursor-pointer'>
                            <MDBIcon fas icon='bars' size='lg' />
                        </div>
                        <h5 class="ms-3 mb-0 d-inline">EasyMembr</h5>
                    </header>
                </>}

                <MDBCard className='shadow-3 overflow-hidden'>
                    <MDBCardBody className='custom-card-height'>
                        <div className="d-flex align-items-center justify-content-between">
                            <h5 className='m-0'>
                                Schedules
                            </h5>
                            <div className="view-mode-toggle">
                                <MDBBtn
                                    color={basicActive === 'tab2' ? 'primary' : 'light'}
                                    size="sm"
                                    onClick={() => handleBasicClick('tab2')}
                                    className="me-2"
                                >
                                    <MDBIcon fas icon="list" className="me-1" />
                                    List View
                                </MDBBtn>
                                <MDBBtn
                                    color={basicActive === 'tab1' ? 'primary' : 'light'}
                                    size="sm"
                                    onClick={() => handleBasicClick('tab1')}
                                >
                                    <MDBIcon far icon="calendar-alt" className="me-1" />
                                    Calendar View
                                </MDBBtn>
                                {roleAccess?.editevent !== 2 &&
                                    <>
                                        <MDBBtn color='success' className='text-capitalize' onClick={toggleOpen}>
                                            <MDBIcon fas icon="plus" className="me-2" />
                                            Add New Schedule</MDBBtn></>}
                            </div>

                        </div>

                        <MDBTabsContent>
                            <MDBTabsPane open={basicActive === 'tab1'}>
                                <ClassesBooking classes={classes} scheduleInfo={scheduleInfo} trainerData={trainerData} policyData={policyData} editCallback={handelEditCallback} deleteCallback={handelDeleteCallback} handlealertDelete={handlealertDelete} plans={plans} />
                            </MDBTabsPane>
                            <MDBTabsPane open={basicActive === 'tab2'}>
                                <NewClassesView editCallback={handelEditCallback} refreshs={refresh} />
                            </MDBTabsPane >
                        </MDBTabsContent >
                    </MDBCardBody >
                </MDBCard >


                <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                    <MDBModalDialog centered size='lg'>
                        <MDBModalContent>
                            <CreateEvent
                                ispopup="0"
                                onSave={handleSave}
                                onclose={handleClose}
                                scheduleinfo={scheduleData}
                                selectedDate={selectedDate}
                            />
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>



                <MDBModal tabIndex="-1" open={deleteModal} onClose={() => setDeleteModal(false)}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Confirm Deletion</MDBModalTitle>
                                <MDBBtn className="btn-close" color="none" onClick={() => setDeleteModal(false)}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p>Are you sure you want to delete this event?</p>
                            </MDBModalBody>
                            <MDBModalFooter className='pe-2 pb-2'>
                                <MDBBtn color="secondary" onClick={() => setDeleteModal(false)}>
                                    Cancel
                                </MDBBtn>
                                {/* <MDBBtn color="danger" onClick={confirmDelete}>
                                    Delete
                                </MDBBtn> */}
                                <MDBBtn color="danger" onClick={(e) => handleDeleteConform(e, true)}>
                                    Delete All Recurring Events
                                </MDBBtn>
                                <MDBBtn color="danger" onClick={(e) => handleDeleteConform(e, false)}>
                                    Delete Only This Event
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                {/* Delete Confirmation Modal */}
                {/* <MDBModal tabIndex="-1" open={deleteModal} onClose={toggleDeleteModal}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Confirm Deletion</MDBModalTitle>
                                <MDBBtn className="btn-close" color="none" onClick={toggleDeleteModal}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p>Are you sure you want to delete this Schedules?</p>
                            </MDBModalBody>
                            <MDBModalFooter className='pe-2 pb-2'>
                                <MDBBtn color="secondary" onClick={toggleDeleteModal}>
                                    Cancel
                                </MDBBtn>
                                <MDBBtn color="danger">
                                    Delete
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal> */}


                <MDBAlert
                    color='success'
                    autohide
                    position='top-center'
                    delay={5000}
                    appendToBody
                    open={Error2 !== ""}
                    onClose={() => setError2("")}
                >
                    {Error2}
                </MDBAlert>

            </SideNavClass >
        </>
    )
}

export default ClassSchedules
